import { FC, useEffect, useState } from 'react';

import { useAuth } from 'src/contexts';
import AdminDashboard from './AdminDashboard';
import UserHome from './UserHome';

const Home: FC = () => {
  const { isAdmin } = useAuth();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isAdmin) {
    return <div>
      <AdminDashboard />
    </div>;
  }

  return <UserHome />;
};

export default Home;
